import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Image, Avatar, Text } from '@atomic';
import { Link } from 'react-router-dom';

const PostWrapper = styled.li`
  width: 100%;
  height: 100%;
  position: relative;
  width: 100%;
`;

const UserInfo = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Post = ({ postInfo }) => {
  const { image, author, _id } = postInfo;

  return (
    <Link to={{ pathname: `/post/${_id}` }}>
      <PostWrapper>
        <Image
          src={image || ''}
          style={{
            borderRadius: '7px',
            cursor: 'pointer',
          }}
          width="100%"
          height="100%"
        />
        <UserInfo>
          <Avatar
            avatarUrl={author.image}
            style={{
              boxShadow: `0 0 10px 3px rgb(0,0,0,0.2)`,
            }}
            borderSize={40}
          />
          <Text
            style={{
              cursor: 'pointer',
              color: 'white',
              textShadow: '0 0 10px black',
            }}
          >
            {author.fullName}
          </Text>
        </UserInfo>
      </PostWrapper>
    </Link>
  );
};

Post.propTypes = {
  postInfo: PropTypes.object.isRequired,
};

export default Post;
